import type { SubmissionFormatType } from './LearnerProjects.types';

export const SUBMISSION_TYPE_UPLOAD = 'upload';
export const SUBMISSION_TYPE_URL = 'url';

// Submission format types - used in submission_formats JSONB array
export const SUBMISSION_FORMAT_SPREADSHEET = 'spreadsheet';
export const SUBMISSION_FORMAT_PDF = 'pdf';
export const SUBMISSION_FORMAT_ZIP = 'zip';
export const SUBMISSION_FORMAT_PRESENTATION_LINK = 'presentation_link';
export const SUBMISSION_FORMAT_GITHUB_LINK = 'github_link';
export const SUBMISSION_FORMAT_GENERIC_LINK = 'generic_link';

// Keep in sync with LearnerProject::SUBMISSION_FORMAT_LABELS in app/models/learner_project.rb.
export const SUBMISSION_FORMAT_LABELS: Record<SubmissionFormatType, string> = {
    [SUBMISSION_FORMAT_SPREADSHEET]: 'Spreadsheet (XLSX)',
    [SUBMISSION_FORMAT_PDF]: 'PDF',
    [SUBMISSION_FORMAT_ZIP]: 'ZIP',
    [SUBMISSION_FORMAT_PRESENTATION_LINK]: 'Presentation Link',
    [SUBMISSION_FORMAT_GITHUB_LINK]: 'GitHub Link',
    [SUBMISSION_FORMAT_GENERIC_LINK]: 'Generic Link',
};

// Mirror of ProjectSubmission::AutoGrader::GRADER_CLASSES for the admin project editor's live hint.
// The server validation is the source of truth.
export const AUTO_GRADABLE_SUBMISSION_FORMATS: SubmissionFormatType[] = [
    SUBMISSION_FORMAT_PDF,
    SUBMISSION_FORMAT_PRESENTATION_LINK,
    SUBMISSION_FORMAT_SPREADSHEET,
];
export const EXCLUSIVE_AUTO_GRADABLE_SUBMISSION_FORMATS: SubmissionFormatType[] = [SUBMISSION_FORMAT_SPREADSHEET];
